import { createContext } from "react";

const ElementHandlerContext = createContext();

export default ElementHandlerContext;
